(() => {
  const observeVideos = (root) => {
    const videos = root.querySelectorAll('[data-pc-lazy-video]');
    if (!videos.length) return;
    const play = (video) => {
      const playback = video.play();
      if (playback) playback.catch(() => {});
    };
    if (!('IntersectionObserver' in window)) {
      videos.forEach(play);
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (isIntersecting && !document.hidden) play(target);
        else target.pause();
      });
    }, { rootMargin: '200px 0px' });
    videos.forEach((video) => observer.observe(video));
  };
  observeVideos(document);
  document.addEventListener('shopify:section:load', (event) => observeVideos(event.target));
})();
